import styled, { css } from 'styled-components';

import { IImagePicker } from './ImagePicker';

export const InputImage = styled.input`
  display: none;
`;

const transitionAxisY = () => {
  return css`
    @keyframes enter {
      0% {
        ${{
          transform: `translateY(100%)`,
        }}
      }
      100% {
        transform: translateY(0);
      }
    }

    @keyframes out {
      0% {
        transform: translateY(0);
      }
      100% {
        ${{
          transform: `translateY(100%)`,
        }}
      }
    }
  `;
};

export const ImagePickerModal = styled.div<IImagePicker.IModalPicker>`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 800;
  top: ${({ showModal }) => (showModal ? 0 : '100%')};
  opacity: ${({ showModal }) => (showModal ? 1 : 0)};
  transition: opacity 0.15s ease-in-out;
  align-items: end;
  background: rgba(28, 38, 49, 0.9);
  backdrop-filter: blur(2px);
  display: flex;
`;

export const ImagePickerContainer = styled.div<IImagePicker.IModalPicker>`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: ${({ showModal }) => (showModal ? '373px' : '0')};
  opacity: ${({ showModal }) => (showModal ? 1 : 0)};
  background-color: ${({ theme }) => theme.colors.gray800};
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  border-radius: 12px 12px 0 0;
  padding: ${({ showModal }) => (showModal ? '36px 24px 24px 24px' : 0)};
  animation: ${({ showModal }) => (showModal ? 'enter' : 'out')};
  opacity: ${({ showModal }) => (showModal ? 1 : 0)};
  transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
  ${() => transitionAxisY()};
`;

export const ImagePickerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ImagePickerTitle = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const ArrowButton = styled.button`
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme.colors.gray900};
  border: none;
  border-radius: 8px;
  font-size: 16px;
`;

export const CameraButton = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 28px;
  border: 1px solid ${({ theme }) => theme.colors.gray0};
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 30px;

  :after {
    content: '';
    min-width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const ExitButton = styled.button`
  align-self: start;
  margin-top: 32px;
  width: 87px;
  height: 32px;
  background-color: transparent;
  border: 1.5px solid ${({ theme }) => theme.colors.gray0};
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.03));
  border-radius: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray0};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: absolute;
  left: 30px;
`;

export const RotatePhone = styled.div`
  position: fixed;
  display: flex;
  background-color: ${({ theme }) => theme.colors.gray900};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  padding: 0 32px;
  z-index: 999;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray0};

  @media all and (orientation: landscape) {
    @media only screen and ${({ theme }) => theme.breakpoints.tabletLandscape} {
      display: none;
    }
  }
`;

export const CameraContainer = styled.div`
  position: fixed;
  display: none;
  background-color: ${({ theme }) => theme.colors.gray900};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  padding: 0 32px;
  z-index: 999;

  .camera {
    height: 100vh;
  }

  @media all and (orientation: landscape) {
    @media only screen and ${({ theme }) => theme.breakpoints.tabletLandscape} {
      display: flex;
    }
  }
`;

export const ImageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.gray900};
  border: 1px solid ${({ theme }) => theme.colors.gray600};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 12px;

  label {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 14px;
    color: ${({ theme }) => theme.colors.gray0};
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    width: 64px;
    height: 64px;
    background-color: ${({ theme }) => theme.colors.gray950};
    border-radius: 8px;

    :before {
      color: ${({ theme }) => theme.colors.gray0};
    }
  }
`;
